// helper
import Util from "@/helper/Utility.js";
/**
 *
 * @param {*} modalStore
 * @returns {import("@/types/Modal.d").AlertModalComposition}
 */
export const useAlertModal = function (modalStore) {
    const modalController = modalStore.methods.getModalController();

    const alertModal = modalController.alertModal

    const showAlertModal = function (title, msg, btnOk = null, opts = {}) {
        return new Promise((resolve) => {
            alertModal
                .clearModal()
                .setTitle(title)
                .setMsg(msg)
            if (btnOk != null) {
                alertModal.setBtnOk(btnOk)
            }
            alertModal.onClickOk((data) => {
                resolve(data)
            })

            alertModal.show(opts)
        })
    };

    const showApiErrorModal = function (title, error, opts = {}) {
        let alertMsg = '';
        if (error?.code) {
            switch (error.code) {
                case 409:
                case 401:
                    alertMsg = error.message;
                    break;
                case 412:
                    alertMsg = "Token invalid";
                    break;
                default:
                    alertMsg = error.message;
                    break;
            }
        } else {
            title = "Network Error"
            alertMsg = "Please try again later";
        }

        if (opts.msg) {
            alertMsg = opts.msg
        }

        alertModal
            .clearModal()
            .setTitle(title)
            .setMsg(alertMsg)
            .show(opts?.type ?? null, opts);

        return alertModal
    };

    const hideAlertModal = function () {
        alertModal
            .clearModal()
            .hide();
    };

    const onClickAlertModalOk = function (callback) {
        if (!Util.isFunction(callback)) return;

        alertModal
            .onClickOk(() => {
                callback();
            });
    };

    return {
        alertModal,
        showAlertModal,
        showApiErrorModal,
        hideAlertModal,
        onClickAlertModalOk
    }
}

export default useAlertModal
